import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export function FAQAccordion({ faqs, idPrefix = "faq" }) {
  return (
    <Accordion type="single" collapsible className="w-full" data-testid={`${idPrefix}-accordion`}>
      {faqs.map((f, i) => (
        <AccordionItem key={i} value={`${idPrefix}-${i}`} className="border-slate-200">
          <AccordionTrigger
            data-testid={`${idPrefix}-question-${i}`}
            className="py-5 text-left font-display text-base font-semibold text-slate-900 hover:text-ember-dark hover:no-underline sm:text-lg"
          >
            {f.q}
          </AccordionTrigger>
          <AccordionContent data-testid={`${idPrefix}-answer-${i}`} className="text-base leading-relaxed text-slate-600">
            {f.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
